// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".adm-spin-loading {\n  --color: var(--adm-color-weak);\n  --size: 32px;\n  width: var(--size);\n  height: var(--size);\n}\n.adm-spin-loading-svg {\n  width: 100%;\n  height: 100%;\n  animation: adm-spin-loading-rotate 0.8s infinite linear;\n}\n.adm-spin-loading-svg > .adm-spin-loading-fill {\n  stroke: var(--color);\n}\n@keyframes adm-spin-loading-rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n", ""]);
// Exports
module.exports = exports;
